import clsx from "clsx";
import { toast, ToastPosition } from "react-toastify";

// constants
const baseClassName = "rounded-md text-white font-sans font-medium p-5 text-md";

export const showSuccessToast = (message: string, position: ToastPosition = "bottom-right") => {
  const className = "bg-green-60";
  toast.success(message, { position, className: clsx(baseClassName, className) });
};

export const showErrorToast = (message: string, position: ToastPosition = "bottom-right") => {
  const className = "bg-red-60";
  toast.success(message, { position, className: clsx(baseClassName, className) });
};

export const showWarningToast = (message: string, position: ToastPosition = "bottom-right") => {
  const className = "bg-yellow-60";
  toast.success(message, { position, className: clsx(baseClassName, className) });
};

export const showInfoToast = (message: string, position: ToastPosition = "bottom-right") => {
  const className = "bg-blue-60";
  toast.success(message, { position, className: clsx(baseClassName, className) });
};
